import SporterMedicalInjuries from 'containers/pages/rehab/SporterMedicalInjuries';
import SporterMedicalHistory from 'containers/pages/rehab/SporterMedicalHistory';
import SporterMedicalIllnesses from 'containers/pages/rehab/SporterMedicalIllnesses';
import SporterMedicalIssues from 'containers/pages/rehab/SporterMedicalIssues';
import { useMedicalContext } from 'contexts/MedicalContext';
import Loader from 'components/loader/Loader';

function SporterMedicalCard() {
  const { loading } = useMedicalContext();

  if (loading) return <Loader />;

  return (
    <>
      <SporterMedicalHistory />
      <SporterMedicalInjuries />
      <SporterMedicalIllnesses />
      <SporterMedicalIssues />
    </>
  );
}

export default SporterMedicalCard;
